import { render, staticRenderFns } from "./ExportPricetable.vue?vue&type=template&id=1820fd92&scoped=true"
import script from "./ExportPricetable.vue?vue&type=script&lang=js"
export * from "./ExportPricetable.vue?vue&type=script&lang=js"
import style0 from "./ExportPricetable.vue?vue&type=style&index=0&id=1820fd92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820fd92",
  null
  
)

export default component.exports